'use strict';

var Mime = require('./Mime');
module.exports = new Mime(require('./types/standard'), require('./types/other'));



//////////////////
// WEBPACK FOOTER
// ./~/_mime@2.4.6@mime/index.js
// module id = 265
// module chunks = 0